module.exports = __webpack_public_path__ + "media/images/header-d31548e62709e885f5ee478812b6cf56.svg";